
import {
	Component,
	OnInit,
	Input,
	EventEmitter,
	Output,
	ViewEncapsulation,
} from '@angular/core';
import { FnFileService } from '../../../services/fn-file.service';
import { FnCloudFile } from './fn-cloud-file.model';

@Component({
	selector: 'fn-file-action-ui',
	templateUrl: './fn-file-action-ui.component.html',
	encapsulation: ViewEncapsulation.None,
})
export class FnFileActionUiComponent implements OnInit {
	@Input() cloudFile: FnCloudFile;
	@Output() actionPerfromOnFile = new EventEmitter<string>();
	@Input() isDeleteDisabled = false;
	constructor(private fnFileService:FnFileService) {}

	ngOnInit(): void {
		this.isDeleteDisabled = this.isDeleteDisabled || !this.cloudFile.canDeleteFile;
		if(!this.cloudFile.fileIcon){
			this.cloudFile.fileIcon = this.fnFileService.getIcons(this.cloudFile.mimeType,this.cloudFile.isUnencrypted);
		}
	}
	fileAction(actionPerfrom: string) {
		this.actionPerfromOnFile.emit(actionPerfrom);
	}
}
